<template>
  <div class="CartNavPopup relative h-full flex items-center">
    <button class="relative text-black focus:outline-none" @click="open">
      <img src="@/assets/icons/shopping-cart.svg" class="w-[25px] md:w-[30.38px]" alt="Shopping Cart" />

      <div
        v-if="cart && cart.items.length > 0 && !cart.processed"
        class="absolute bg-primary text-white rounded-full size-6 md:size-8 flex justify-center items-center -right-3 -top-[6px]"
      >
        {{ cart.items.length }}
      </div>
    </button>

    <portal to="expressCheckoutPortal">
      <ExpressCheckout v-if="nav" :cart="cart" :checkoutPath="checkoutPath" />
    </portal>
  </div>
</template>

<script>
import ExpressCheckout from "./ExpressCheckout.vue"
import CURRENT_QUERY from "@/queries/Current.query.gql"
import { getters, actions } from "./navStore.js"

export default {
  name: "Cart.CounterBtn",
  props: {
    checkoutPath: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    hover: false,
    cart: null,
  }),
  apollo: {
    cart: {
      query: CURRENT_QUERY,
      update: ({ checkoutCart }) => checkoutCart,
    },
  },
  mounted() {
    const ssrCartMobile = document.getElementById("ssr-cart-mobile")
    ssrCartMobile.classList.add("hidden")

    document.addEventListener("product:cart-change", this.handleModernProductCall)
  },
  methods: {
    refetch() {
      this.$apollo.queries.cart.refetch()
    },
    handleModernProductCall() {
      this.refetch()
      actions.open()
    },
    ...actions,
  },
  computed: {
    ...getters,
  },
  watch: {
    cart: {
      deep: true,
      handler(cart, oldCart) {
        if (cart == null || oldCart == null) return

        if (cart.items.length === 0) this.close()
      },
    },
    nav: {
      handler() {
        this.$apollo.queries.cart.refetch()
      },
    },
  },
  components: {
    ExpressCheckout,
  },
}
</script>
